import { ApiPagedRequest, ApiRequest } from 'app/common/types'
import { ApiPagedResponse } from 'app/common/types/api'
import { InstalledConnection } from 'app/connections/types'

import { Campaign } from './campaign'

export interface TreatmentsGetContent {
  id?: string[]
  connection?: string[]
}

export type TreatmentsGetRequest = ApiRequest<TreatmentsGetContent> & ApiPagedRequest

export interface TreatmentEntity {
  properties: { status: 'active' | 'paused' | 'removed' | 'inactive' }
  conversion: string
  id: string
  name: string
  relates_to: { campaign: Campaign; adset?: { id: string; name: string } }
  connection: string
}

export interface TreatmentsGetResponse extends ApiPagedResponse {
  data: TreatmentEntity[]
}

export type Treatment = {
  properties: TreatmentEntity['properties']
  campaign: Campaign
  adset?: { id: string; name: string }
  id: string
  name: string
  connection: InstalledConnection | null
}

const mapToTreatment = (
  treatmentEntity: TreatmentEntity,
  connections: InstalledConnection[],
): Treatment => ({
  properties: treatmentEntity.properties,
  campaign: treatmentEntity.relates_to.campaign,
  adset: treatmentEntity.relates_to.adset,
  id: treatmentEntity.id,
  name: treatmentEntity.name,
  connection: connections.find((conn) => conn.id === treatmentEntity.connection) ?? null,
})

export const mapToTreatments = (
  treatmentEntities: TreatmentEntity[],
  connections: InstalledConnection[],
): Treatment[] =>
  treatmentEntities.map((treatmentEntity) => mapToTreatment(treatmentEntity, connections))
